import React from 'react';
import { motion } from 'framer-motion';
import {
	FaTwitter,
	FaGithub,
	FaLinkedin,
	FaEnvelopeSquare,
	FaPhoneSquareAlt,
} from 'react-icons/fa';
// import { FaInstagram } from "react-icons/fa";

const linksVariants = {
	hover: {
		color: 'hsl(205.1, 100%, 36.1%)',
		boxShadow: '0px 0px 6px rgb(255, 255, 255)',
		transition: {
			duration: 0.3,
		},
	},
};

function Footer() {
	const date = new Date();
	const fullYear = date.getFullYear();

	return (
		<footer className="max-w-screen-2xl h-fit m-auto mt-24 mb-10">
			<div className="w-11/12 mx-auto pt-5 flex flex-col justify-center items-center border-t border-solid border-[hsl(204,23.8%,95.9%,.12)]">
				<div className="w-full flex flex-row justify-center sm:justify-start gap-5 items-center">
					<motion.a
						href="https://twitter.com/mmajudith1"
						target="blank"
						className="text-2xl"
						variants={linksVariants}
						whileHover="hover"
					>
						<FaTwitter />
					</motion.a>
					<motion.a
						href="https://github.com/mmajudith"
						target="blank"
						className="text-2xl"
						variants={linksVariants}
						whileHover="hover"
					>
						<FaGithub />
					</motion.a>
					<motion.a
						href="https://www.linkedin.com/in/judith-onyekwelu-b96655205"
						target="blank"
						className="text-2xl"
						variants={linksVariants}
						whileHover="hover"
					>
						<FaLinkedin />
					</motion.a>
					<motion.a
						href="tel:07036426150"
						className="text-2xl"
						variants={linksVariants}
						whileHover="hover"
					>
						<FaPhoneSquareAlt />
					</motion.a>
					<motion.a
						href="mailto:judithonyekwelu01@gmail.com"
						className="text-2xl"
						variants={linksVariants}
						whileHover="hover"
					>
						<FaEnvelopeSquare />
					</motion.a>
				</div>

				<div className="w-full mx-auto pt-5 text-xs xs:text-sm text-center font-light">
					<p>&#169; Judith Onyekwelu {fullYear}.</p>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
